import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import { StateStatus } from '@alycecom/utils';

import {
  pollThanksRedeemStatus,
  sendThanksFail,
  sendThanksRequest,
  sendThanksSuccess,
  thanksStatusFail,
  thanksStatusRequest,
  thanksStatusSuccess,
} from './thanks.actions';

export interface IThanksState {
  isLoading: boolean;
  sent: boolean;
  redeemLink: string;
  delayedGiftCard: boolean;
  isFormLoading: boolean;
  pollingStatus: StateStatus;
  errors: TLegacyErrors;
}

export const initialState: IThanksState = {
  isLoading: false,
  sent: false,
  redeemLink: '',
  delayedGiftCard: false,
  isFormLoading: false,
  pollingStatus: StateStatus.Idle,
  errors: {},
};

const reducer = createReducer<IThanksState>({}, initialState);

reducer
  .on(thanksStatusRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(thanksStatusSuccess, (state, payload) => ({
    ...state,
    sent: payload.sent,
    redeemLink: payload.redeemLink,
    delayedGiftCard: payload.delayedGiftCard,
    isLoading: false,
  }))
  .on(thanksStatusFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer
  .on(sendThanksRequest, state => ({
    ...state,
    isFormLoading: true,
  }))
  .on(sendThanksSuccess, state => ({
    ...state,
    sent: true,
    isFormLoading: false,
  }))
  .on(sendThanksFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer
  .on(pollThanksRedeemStatus.pending, state => ({
    ...state,
    pollingStatus: StateStatus.Pending,
  }))
  .on(pollThanksRedeemStatus.fulfilled, (state, payload) => ({
    ...state,
    pollingStatus: StateStatus.Fulfilled,
    ...payload,
  }))
  .on(pollThanksRedeemStatus.canceled, (state, payload) => ({
    ...state,
    pollingStatus: StateStatus.Idle,
    ...payload,
  }))
  .on(pollThanksRedeemStatus.rejected, (state, payload) => ({
    ...state,
    pollingStatus: StateStatus.Rejected,
    errors: payload,
  }));

export default reducer;
